import React, { useState, useEffect } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  IconButton,
  TextField,
  Autocomplete,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { API, graphqlOperation } from "aws-amplify";
import { updateHSNSACMaster } from "../../../graphql/mutations";
import { createHSNSACMaster } from "../../../graphql/";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import useSaveModalShortcut from "../Components/useSaveModalShortcut";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  outline: "none",
  "@media (min-width:600px)": {
    minWidth: "500px",
    width: "auto",
  },
  width: "90%",
};
function AddHSNModal({
  open,
  setOpen,
  searchHSNSAC,
  hsnParamsID,
  setData,
  type,
  data,
  page,
  setFilterHSN,
  filteredHSN,
  itemType,
  rowIndex,
  updatetedTableRow,
}) {
  const codeTypes = [
    { label: "HSN Code", value: "HSN" },
    { label: "SAC Code", value: "SAC" },
  ];
  // Ledger / non-item and SERVICE → SAC; GOODS (and unset) → HSN
  let Ctype =
    itemType === "SERVICE" || itemType === "ledger"
      ? { label: "SAC Code", value: "SAC" }
      : { label: "HSN Code", value: "HSN" };
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    codeType: Ctype,
    hsnCode: "",
    description: "",
    errorStatus: {
      codeType: false,
      hsnCode: false,
      description: false,
    },
    errorFields: {
      codeType: "",
      hsnCode: "",
      description: "",
    },
  });

  const handleClose = (event, reason) => {
    setState((prev) => ({
      ...prev,
      codeType: { label: "", value: "" },
      hsnCode: "",
      description: "",
      errorStatus: {
        ...prev.errorStatus,
        codeType: false,
        hsnCode: false,
        description: false,
      },
      errorFields: {
        ...prev.errorFields,
        codeType: "",
        hsnCode: "",
        description: "",
      },
    }));

    setOpen(false);
  };

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };

    Object.keys(data).map((key) => {
      if (key === "codeType") {
        if (data[key].value === "") {
          isvalid = false;
          obj.errorFields.codeType = "Code Type is required";
          obj.errorStatus.codeType = true;
        } else {
          obj.errorFields.codeType = "";
          obj.errorStatus.codeType = false;
        }
      }
      if (key === "hsnCode") {
        if (data[key] === "" || data[key] == 0) {
          isvalid = false;
          obj.errorFields.hsnCode =
            page === "GOODS"
              ? "HSN Code is required"
              : page === "SERVICE"
              ? "SAC Code is required"
              : "HSN/SAC Code is required";
          obj.errorStatus.hsnCode = true;
        } else {
          obj.errorFields.hsnCode = "";
          obj.errorStatus.hsnCode = false;
        }
      }
      if (key === "description") {
        if (data[key] === "") {
          isvalid = false;
          obj.errorFields.description = "Description is required";
          obj.errorStatus.description = true;
        } else if (data[key].length > 250) {
          isvalid = false;
          obj.errorFields.description =
            "Description must be less than 250 characters";
          obj.errorStatus.description = true;
        } else {
          obj.errorFields.description = "";
          obj.errorStatus.description = false;
        }
      }
    });
    setState(obj);
    return isvalid;
  }
  async function saveChanges() {
    try {
      const { hsnCode, codeType, description } = state;
      const formData = {
        hsnCode,
        codeType,
        description,
      };
      let hsnCodeObj = {};
      const comments = description.split("\n");
      if (formValidation(formData)) {
        setLoading(true);
        if (hsnParamsID === "") {
          hsnCodeObj = {
            codetype: codeType.value,
            hsnsaccode: String(hsnCode),
            description: comments?.join("**"),
          };
          saveHsnSacCode(hsnCodeObj);
        } else {
          hsnCodeObj = {
            hsnsacid: data?.HSN?.hsnID,
            codetype: codeType.value,
            hsnsaccode: String(hsnCode),
            description: comments?.join("**"),
          };
          updateHsnSacCode(hsnCodeObj);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function saveHsnSacCode(data) {
    try {
      const resHsnSacMaster = await API.graphql(
        graphqlOperation(createHSNSACMaster, {
          createHSNSACMasterInput: data,
        })
      );
      if (resHsnSacMaster.data.createHSNSACMaster.statuscode === "Success") {
        if (page === "Invoice") {
          updatetedTableRow[rowIndex] = {
            ...updatetedTableRow[rowIndex],
            HSN: {
              label: `${resHsnSacMaster.data.createHSNSACMaster.hsnsaccode}-${resHsnSacMaster.data.createHSNSACMaster.description}`,
              value: resHsnSacMaster.data.createHSNSACMaster.hsnsaccode,
              companyID: resHsnSacMaster.data.createHSNSACMaster.companyid,
              codeType: resHsnSacMaster.data.createHSNSACMaster.codetype,
              hsnID: resHsnSacMaster.data.createHSNSACMaster.hsnsacid,
              hsnCode: resHsnSacMaster.data.createHSNSACMaster.hsnsaccode,
              description: resHsnSacMaster.data.createHSNSACMaster.description,
            },
          };
          setData(updatetedTableRow);
        } else {
          setData((prev) => ({
            ...prev,
            hsnCode: {
              label: `${resHsnSacMaster.data.createHSNSACMaster.hsnsaccode}-${resHsnSacMaster.data.createHSNSACMaster.description}`,
              value: resHsnSacMaster.data.createHSNSACMaster.hsnsaccode,
              companyID: resHsnSacMaster.data.createHSNSACMaster.companyid,
              codeType: resHsnSacMaster.data.createHSNSACMaster.codetype,
              hsnID: resHsnSacMaster.data.createHSNSACMaster.hsnsacid,
              hsnCode: resHsnSacMaster.data.createHSNSACMaster.hsnsaccode,
              description: resHsnSacMaster.data.createHSNSACMaster.description,
            },
              errorStatus: {
                      ...prev.errorStatus,
                      hsnCode: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      hsnCode: '',
                    },
          }));
        }
        // let arr = [...filteredHSN].reverse()
        let arr = filteredHSN;
        arr?.unshift({
          label: `${resHsnSacMaster.data.createHSNSACMaster.hsnsaccode}-${resHsnSacMaster.data.createHSNSACMaster.description}`,
          value: resHsnSacMaster.data.createHSNSACMaster.hsnsaccode,
          companyID: resHsnSacMaster.data.createHSNSACMaster.companyid,
          codeType: resHsnSacMaster.data.createHSNSACMaster.codetype,
          hsnID: resHsnSacMaster.data.createHSNSACMaster.hsnsacid,
          hsnCode: resHsnSacMaster.data.createHSNSACMaster.hsnsaccode,
          description: resHsnSacMaster.data.createHSNSACMaster.description,
        });
        setFilterHSN(arr);
        if (itemType === "ledger") {
          searchHSNSAC(resHsnSacMaster.data.createHSNSACMaster.hsnsaccode);
        } else {
          searchHSNSAC(
            resHsnSacMaster.data.createHSNSACMaster.hsnsaccode,
            itemType
          );
        }
        showSuccessSnackbar(
          page === "GOODS"
            ? "HSN Code created Successfully"
            : page === "SERVICE"
            ? "SAC Code is created Successfully"
            : "HSN/SAC Code created Successfully"
        );
        setOpen(false);
        setLoading(false);
      } else {
        showErrorSnackbar(
          resHsnSacMaster.data.createHSNSACMaster.statusmessage
        );
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      const fullMessage = JSON.parse(
        error.errors[0].message.replace("RDSHttp:", "")
      ).message;
      const cleanMessage = fullMessage.replace("ERROR: ", "").split(";")[0];
      showWarningSnackbar(cleanMessage);
    }
  }
  async function updateHsnSacCode(data) {
    try {
      const resHsnSacMaster = await API.graphql(
        graphqlOperation(updateHSNSACMaster, {
          updateHSNSACMasterInput: data,
        })
      );
      if (resHsnSacMaster.data.updateHSNSACMaster.StatusCode === null) {
        if (page === "Invoice") {
          updatetedTableRow[rowIndex] = {
            ...updatetedTableRow[rowIndex],
            HSN: {
              label: `${resHsnSacMaster.data.updateHSNSACMaster.HSNSACCode}-${resHsnSacMaster.data.updateHSNSACMaster.Description}`,
              value: resHsnSacMaster.data.updateHSNSACMaster.HSNSACCode,
              companyID: resHsnSacMaster.data.updateHSNSACMaster.CompanyID,
              codeType: resHsnSacMaster.data.updateHSNSACMaster.CodeType,
              hsnID: resHsnSacMaster.data.updateHSNSACMaster.HSNSACID,
              hsnCode: resHsnSacMaster.data.updateHSNSACMaster.HSNSACCode,
              description: resHsnSacMaster.data.updateHSNSACMaster.Description,
            },
          };
          setData(updatetedTableRow);
        } else {
          setData((prev) => ({
            ...prev,
            hsnCode: {
              label: `${resHsnSacMaster.data.updateHSNSACMaster.HSNSACCode}-${resHsnSacMaster.data.updateHSNSACMaster.Description}`,
              value: resHsnSacMaster.data.updateHSNSACMaster.HSNSACCode,
              companyID: resHsnSacMaster.data.updateHSNSACMaster.CompanyID,
              codeType: resHsnSacMaster.data.updateHSNSACMaster.CodeType,
              hsnID: resHsnSacMaster.data.updateHSNSACMaster.HSNSACID,
              hsnCode: resHsnSacMaster.data.updateHSNSACMaster.HSNSACCode,
              description: resHsnSacMaster.data.updateHSNSACMaster.Description,
            },
              errorStatus: {
                      ...prev.errorStatus,
                      hsnCode: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      hsnCode: '',
                    },
          }));
        }
        if (itemType === "ledger") {
          searchHSNSAC(resHsnSacMaster.data.updateHSNSACMaster.HSNSACCode);
        } else {
          searchHSNSAC(
            resHsnSacMaster.data.updateHSNSACMaster.HSNSACCode,
            itemType
          );
        }
        showSuccessSnackbar(
          page === "GOODS"
            ? "HSN Code updated"
            : page === "SERVICE"
            ? "SAC Code updated"
            : "HSN/SAC Code updated"
        );
        setOpen(false);
        setLoading(false);
      } else {
        showErrorSnackbar(
          resHsnSacMaster.data.updateHSNSACMaster.StatusMessage
        );
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      const fullMessage = JSON.parse(
        error.errors[0].message.replace("RDSHttp:", "")
      ).message;
      const cleanMessage = fullMessage.replace("ERROR: ", "").split(";")[0];
      showWarningSnackbar(cleanMessage);
    }
  }
  async function getEdiedHsnSacData(data) {
    try {
      let codeTypeObj = Ctype;
      codeTypes.map((ele) => {
        if (ele.value === data?.HSN?.codeType) {
          codeTypeObj = { label: ele.label, value: ele.value };
        }
      });

      setState((prev) => ({
        ...prev,
        codeType: codeTypeObj,
        hsnCode: data?.HSN?.value,
        description: data?.HSN?.description,
      }));
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    if (hsnParamsID !== "") {
      getEdiedHsnSacData(data);
    }
  }, [data]);
  useEffect(() => {
    if (page === "GOODS") {
      setState((prev) => ({
        ...prev,
        codeType: { label: "HSN Code", value: "HSN" },
      }));
    }
    if (page === "SERVICE") {
      setState((prev) => ({
        ...prev,
        codeType: { label: "SAC Code", value: "SAC" },
      }));
    }
  }, [page, open]);
    useSaveModalShortcut(saveChanges)
  return (
    <Box id={open ? "AddHSNModal" : ""}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
        // sx={{zIndex:5501}}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {hsnParamsID === ""
                    ? page === "GOODS"
                      ? "Add HSN Code"
                      : page === "SERVICE"
                      ? "Add SAC Code"
                      : "Add HSN/SAC Code"
                    : "Edit HSN/SAC Code"}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: { xs: "5px", sm: "15px" },
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ flex: 1, m: 1 }}>
                <Autocomplete
                  disablePortal
                  id="codeType"
                  disableClearable
                  disabled={itemType==="ledger"?false:true}
                  // disabled={false}
                  options={codeTypes}
                  isOptionEqualToValue={(option, value) =>
                    option.value == value.value
                  }
                  value={state.codeType}
                  onChange={(e, newValue) => {
                    if (newValue === "") {
                      setState((prev) => ({
                        ...prev,
                        codeType: newValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          codeType: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          codeType: "Code Type   is required",
                        },
                      }));
                    } else {
                      setState((prev) => ({
                        ...prev,
                        codeType: newValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          codeType: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          codeType: "",
                        },
                      }));
                    }
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      required={state.codeType.value === "" ? true : false}
                      error={state.errorStatus.codeType === true ? true : false}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      {...params}
                      label="Code Type"
                      sx={{
                        ".css-wgai2y-MuiFormLabel-asterisk": {
                          color: "danger.main",
                          fontSize: "16px",
                          fontWeight: "bold",
                        },
                      }}
                    />
                  )}
                />
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {state?.errorFields.codeType}
                </Typography>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  m: 1,
                }}
              >
                <TextField
                  error={state.errorStatus.hsnCode === true ? true : false}
                  required={state.hsnCode === "" ? true : false}
                  label={
                    page === "GOODS"
                      ? "HSN Code"
                      : page === "SERVICE"
                      ? "SAC Code"
                      : "HSN/SAC Code"
                  }
                  name="hsnCode"
                  size="small"
                  fullWidth
                  value={state.hsnCode}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^[0-9]+$/;

                    if (value === "" || value == 0) {
                      setState((prev) => ({
                        ...prev,
                        hsnCode: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          hsnCode: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          hsnCode:
                            page === "GOODS"
                              ? "HSN Code is required"
                              : page === "SERVICE"
                              ? "SAC Code is required"
                              : "HSN/SAC Code is required",
                        },
                      }));
                    } else {
                      if (regex.test(value)) {
                        setState((prev) => ({
                          ...prev,
                          hsnCode: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            hsnCode: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            hsnCode: "",
                          },
                        }));
                      }
                    }
                  }}
                  sx={{
                    ".css-wgai2y-MuiFormLabel-asterisk": {
                      color: "danger.main",
                      fontSize: "16px",
                      fontWeight: "bold",
                    },
                  }}
                />
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {state?.errorFields.hsnCode}
                </Typography>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  m: 1,
                }}
              >
                <TextField
                  error={state.errorStatus.description === true ? true : false}
                  name="description"
                  label="Description"
                  state={state}
                  size="small"
                  multiline
                  fullWidth
                  required={state.description === "" ? true : false}
                  value={state.description}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "") {
                      setState((prev) => ({
                        ...prev,
                        description: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          description: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          description: "Description is required",
                        },
                      }));
                    } else {
                      if (e.target.value.length > 250) {
                        setState((prev) => ({
                          ...prev,
                          description: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            description: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            description:
                              "Description must be less than 250 characters",
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          description: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            description: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            description: "", // Corrected typo here
                          },
                        }));
                      }
                    }
                  }}
                  rows={3}
                  sx={{
                    ".MuiInputBase-root": {
                      height: "100%",
                    },
                    ".css-wgai2y-MuiFormLabel-asterisk": {
                      color: "danger.main",
                      fontSize: "16px",
                      fontWeight: "bold",
                    },
                  }}
                />

                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {state?.errorFields.description}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                // flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={loading}
                disableRipple={true}
                onClick={saveChanges}
                variant="contained"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                {hsnParamsID === "" ? "ADD" : "SAVE"}
              </LoadingButton>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
}

export default AddHSNModal;
